/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { FC, ReactElement, useContext, useEffect, useState } from 'react';
import { getStandings } from '../../services/http/httpService';
import { CompetitionsContext, PrefferencesContext } from '../../context/context';
import { IIceHockeyStanding, IIceHockeyStandingResponse } from '../../interfaces/interfaces';
import { REFRESH_INTERVAL, WIDGET_WIDTH } from '../../config/config';
import TableLoader from '../loader/loader';
import { getParameterByName, trans } from '../../helpers/helperFunctions';

const Table: FC = (): ReactElement | null => {
  const { selectedCompetition, matchDay } = useContext(CompetitionsContext);
  const { language, widgetWidth } = useContext(PrefferencesContext);
  const { activeSeasonId, competitionId } = selectedCompetition;
  const [loading, setLoading] = useState<boolean>(true);
  const [standings, setStandings] = useState<IIceHockeyStandingResponse[]>([]);
  const collapsed = getParameterByName('collapsed');
  const [isCollapsed, setIsCollapsed] = useState(collapsed === 'true');

  // Fetches standings when a competition is selected manually or on load, and registers refresh
  useEffect(() => {
    // do not send request
    if (!activeSeasonId || matchDay === null) return undefined;
    setLoading(true);
    getStandings(activeSeasonId, matchDay, language)
      .then((response) => {
        setLoading(false);
        setStandings(response);
      })
      .catch((e) => {
        console.log('Error fetching standings');
        setLoading(false);
      });

    // Register interval to re-fetch standings
    const standingsInterval = setInterval(() => {
      if (!activeSeasonId || matchDay === null) return;
      getStandings(activeSeasonId, matchDay, language)
        .then((response) => {
          setStandings(response);
        })
        .catch((e) => {
          console.log('Error fetching standings');
        });
    }, REFRESH_INTERVAL);

    return () => clearInterval(standingsInterval);
  }, [activeSeasonId, matchDay, competitionId]);

  const selectedStandings = standings[0]?.standings;

  return (selectedStandings && selectedStandings?.length > 0) || loading ? (
    createStandingsTable(selectedStandings, loading, widgetWidth, isCollapsed, setIsCollapsed)
  ) : (
    <div />
  );
};

function createStandingsTable(
  standings: IIceHockeyStanding[] | undefined,
  loading: boolean,
  widgetWidth: number,
  isCollapsed: boolean,
  setIsCollapsed: (arg: boolean) => void
): ReactElement {
  return (
    <div className="table-container">
      <i
        aria-hidden="true"
        className="material-icons collapse-icon"
        onClick={() => setIsCollapsed(!isCollapsed)}>
        {isCollapsed ? 'unfold_more' : 'unfold_less'}
      </i>{' '}
      <p className="table-title">{trans('table')}</p>
      {!isCollapsed && (
        <div className="row-titles">
          <p>{trans('team')}</p>
          <p>{trans('game')}</p>
          <p>{trans('goals')}</p>
          <p>{trans('differencesOfGoals')}</p>
          <p>{trans('points')}</p>
        </div>
      )}
      {loading ? (
        <TableLoader viewBox="10 10 1200 720" />
      ) : (
        !isCollapsed && (
          <table className="standings-table">
            <tbody>
              {standings?.map((row, index) => {
                const {
                  rank,
                  teamLogoUrl,
                  contestantName,
                  matchesPlayed,
                  goalsFor,
                  goalsAgainst,
                  goalDifference,
                  teamMicroName,
                  points
                } = row;
                const teamName = widgetWidth <= WIDGET_WIDTH ? teamMicroName : contestantName;
                return (
                  <tr key={`${rank}${index}${Math.random()}`}>
                    <td>{`${rank}.`}</td>
                    <td>
                      <img src={teamLogoUrl} alt="Team logo" />
                    </td>
                    <td>{teamName}</td>
                    <td>{matchesPlayed}</td>
                    <td>{`${goalsFor}:${goalsAgainst}`}</td>
                    <td>{goalDifference}</td>
                    <td>{points}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )
      )}
    </div>
  );
}

export default Table;
